import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './assets/css/index.css';
import { Provider } from 'react-redux';

import store from './store';

import './assets/vendor/nucleo/css/nucleo.css';
import './assets/vendor/@fortawesome/fontawesome-free/css/all.min.css';
import './assets/scss/argon-dashboard-react.scss';
import './assets/customStyle.css';

import AdminLayout from './layouts/Admin.jsx';
import AuthLayout from './layouts/Auth.jsx';
/*
if (
  window.location.protocol !== 'https:' &&
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== 'portal2.servissoft.net'
) {
  window.location =
    'https:' + window.location.href.substring(window.location.protocol.length);
}
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/" element={<Navigate to="/admin/index" replace />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
